module.exports = __webpack_public_path__ + "static/img/11.85ae216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/11.png
// module id = 9ZJx
// module chunks = 1